import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import LoginReducer from './login-reducer';
import FooterReducer from './footer-reducer';
import UnitReducer from './unit-reducer';
import InstructionReducer from './instruction-hidro-reducer';
import InstructionTermReducer from './instruction-term-reducer';
import ProductionReducer from './production-hidro-reducer';
import ProductionActiveReducer from './production-hidro-active-reducer';
import ProductionTermReducer from './production-term-reducer';
import UserReducer from './user-reducer';
import HistoryReducer from './history-hidro-reducer';
import HistoryTermReducer from './history-term-reducer';
import CenterReducer from './center-reducer';
import RulesReducer from './rules-reducer';
import CIReducer from './ci-reducer';
import IOReducer from './io-reducer';
import FIReducer from './fi-reducer';
import CCReducer from './cc-reducer';
import FCReducer from './fc-reducer';
import AllSheetsReducer from './all-sheets-reducer';
import ToDoStore from './to-do-reducer';
/**modulos HC */
import CPReducer from './cp-reducer';
import FPReducer from './fp-reducer';
import PMReducer from './pm-reducer';
import ISReducer from './is-reducer';

const reducers = {
    loginStore: LoginReducer,
    footerStore: FooterReducer,
    instructionStore: InstructionReducer,
    instructionTermStore: InstructionTermReducer,
    productionStore: ProductionReducer,
    productionActiveStore: ProductionActiveReducer,
    productionTermStore: ProductionTermReducer,
    historyStore: HistoryReducer,
    historyTermStore: HistoryTermReducer,
    centerStore: CenterReducer,
    unitStore: UnitReducer,
    userStore: UserReducer,
    form: formReducer,
    rulesStore: RulesReducer,
    ciStore: CIReducer,
    ioStore: IOReducer,
    fiStore: FIReducer,
    ccStore: CCReducer,
    fcStore: FCReducer,
    allSheetsStore: AllSheetsReducer,
    toDoStore: ToDoStore,
    cpStore: CPReducer,
    fpStore: FPReducer,
    pmStore: PMReducer,
    isStore: ISReducer
};
  
const rootReducer = combineReducers(reducers);
  
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js